import React from 'react';
import ToolTip from 'components/tooltip';
import checkboxFilterStyles from './perspectives-checkbox-filter.module.scss';

export interface IPerspectivesCheckboxFilter {
	filter: {
		label: string;
		value: string;
		description?: string;
	};

	handleCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	selectedMediaType: string[];
	tooltipID?: string;
}

export const PerspectivesCheckboxFilter = ({
	filter,
	handleCheckboxChange,
	selectedMediaType,
	tooltipID,
}: IPerspectivesCheckboxFilter) => {
	return (
		<div className={checkboxFilterStyles.filter}>
			<input
				className={checkboxFilterStyles.filterInput}
				type="checkbox"
				id={`filter-${filter.value}`}
				name={`filter-${filter.value}`}
				value={filter.value}
				onChange={handleCheckboxChange}
				checked={selectedMediaType.includes(filter.value)}
			/>
			<label
				htmlFor={`filter-${filter.value}`}
				className={checkboxFilterStyles.filterLabel}
			>
				{filter.label}
			</label>
			{!!filter.description && !!tooltipID && (
				<ToolTip description={filter.description} id={tooltipID} />
			)}
		</div>
	);
};
